<script setup>
import {ref, inject, watch, reactive} from "vue";
import needsStartupsService from "@/services/needs-startups.service";

const startup = inject('startup');
const linkId = inject('linkId');
const updateRating = inject('updateRating');
const escalated = inject('escalated');

const editMode = ref(false);

const reviewForm = reactive({
    rating: 0,
    review: ''
});

watch(editMode, (value) => {
    if (value) {
        if (startup.value.rating) {
            reviewForm.rating = startup.value.rating;
        }

        if (startup.value.review) {
            reviewForm.review = startup.value.review;
        }
    }
}, {immediate: true})

function starClicked(rating) {
    if (escalated.value) {
        return;
    }

    if (editMode.value) {
        reviewForm.rating = rating
    } else {
        if (!startup.value.rating) {
            reviewForm.rating = rating;
            editMode.value = true;
        }
    }
}

async function save() {
    const {data} = await needsStartupsService.saveStartupReview(linkId.value, reviewForm);

    startup.value.rating = data.rating;
    startup.value.review = data.review;
    editMode.value = false;

    updateRating(linkId.value, data.rating);
}

function cancel() {
    editMode.value = false;

}

</script>

<template>
    <div
        :class="['rating-section mb-2', { 'rating-section--complex': editMode || startup.rating }]"
    >
        <div class="rating">
            <span
                v-for="index in [1,2,3,4,5]"
                :key="index"
                :class="{'rating__current': (editMode ? reviewForm.rating : startup.rating) >= index}"
                @click="starClicked(index)"
            />
        </div>

        <div v-if="editMode" class="rating-section--complex__links">
            <a v-if="reviewForm.rating" @click="save" class="link">Save</a>
            <a @click="cancel" class="link">Cancel</a>
        </div>

        <div v-if="editMode" class="rating-section--complex__enter">
            <textarea v-model="reviewForm.review"/>
        </div>

        <template v-else>
            <template v-if="!escalated">
                <a v-if="!startup.rating"
                   @click="editMode = true"
                   class="rating-section__add"
                >
                    Click to add rating
                </a>

                <a
                    v-else
                    @click="editMode = true"
                    class="link-edit"
                >
                </a>
            </template>

            <p class="modal-text">{{startup.review}}</p>
        </template>
    </div>
</template>

<style scoped>

</style>
